<template>
  <div class="dilu-page">
    <div class="search">
      <el-form :inline="true" :model="searchParams">
        <el-form-item label="统计周期">
          <el-select v-model="searchParams.dataType" style="width:100px;margin-right:20px;">
            <el-option label="时" value="hour" />
            <el-option label="日" value="day" />
            <el-option label="周" value="week" />
            <el-option label="月" value="month" />
            <el-option label="年" value="year" />
          </el-select>
        </el-form-item>
        <el-form-item label="统计电表">
          <el-select v-model="searchParams.deviceId" style="width:200px;margin-right:20px;" placeholder="请选择电表">
              <el-option v-for="item in deviceList" :key="item.deviceId" :label="item.deviceName" :value="item.deviceId"/>
          </el-select>
        </el-form-item>
        <el-form-item label="日期范围">
          <el-date-picker type="daterange" placeholder="选择日期" value-format="yyyy-MM-dd" format="yyyy-MM-dd" v-model="searchParams.createdAt" style="width: 300px" clearable/>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="goSearch" style="width:80px;margin-left:20px;">查 询</el-button>
          <el-button type="success" @click="dianJia" style="width:100px;margin-left:20px;">尖峰谷平</el-button>
          <el-button type="success" @click="guanLian" style="width:100px;margin-left:20px;">关联电表</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="project-table">
      <DiluTable v-if="searchParams.dataType=='hour'" :list="hourData" :tableConfig="tableConfig" :total="hourTotal" :pageSize="searchParams.pageSize" @currentChange="currentChange">
        <el-table-column label="统计时段" align="left" width="120" :formatter="formatDate"/>
        <el-table-column prop="period" label="时段类型" width="100" align="left">
          <template slot-scope="scope">
            <span v-if="scope.row.period == 'jian'">尖</span>
            <span v-if="scope.row.period == 'feng'">峰</span>
            <span v-if="scope.row.period == 'gu'">谷</span>
            <span v-if="scope.row.period == 'ping'">平</span>
            <span v-if="scope.row.period == 'shen'">深谷</span>
          </template>
        </el-table-column>
        <el-table-column prop="price" label="时段电价" align="left" width="120"/>
        <el-table-column prop="consume" label="消耗电量" align="left" width="120" />
        <el-table-column prop="pvalue" label="上次数据" align="left" width="100"/>
        <el-table-column prop="ptime" label="上次采集" align="left" width="180"/>
        <el-table-column prop="dvalue" label="本次数据" align="left" width="100"/>
        <el-table-column prop="dtime" label="本次采集" align="left" width="180"/>
        <el-table-column prop="deviceName" label="电表名称" align="left" width="180"/>
      </DiluTable>
      <DiluTable v-if="searchParams.dataType!='hour'" :list="staticData" :tableConfig="tableConfig" :total="staticTotal" :pageSize="searchParams.pageSize" @currentChange="currentChange">
        <el-table-column prop="dataLabel" label="统计日期" align="left" width="120"/>
        <el-table-column prop="energyJian" label="尖时段电量" align="left" width="120"/>
        <el-table-column prop="energyFeng" label="峰时段电量" align="left" width="120"/>
        <el-table-column prop="energyPing" label="平时段电量" align="left" width="120"/>
        <el-table-column prop="energyGu" label="谷时段电量" align="left" width="120"/>
        <el-table-column prop="energyTotal" label="总计电量" align="left" width="100"/>
        <el-table-column prop="moneyJian" label="尖时段电费" align="left" width="120"/>
        <el-table-column prop="moneyFeng" label="峰时段电费" align="left" width="120"/>
        <el-table-column prop="moneyPing" label="平时段电费" align="left" width="120"/>
        <el-table-column prop="moneyGu" label="谷时段电费" align="left" width="120"/>
        <el-table-column prop="moneyTotal" label="总计电费" align="left" width="100"/>
        <el-table-column prop="dataType" label="数据类型" width="100" align="left">
          <template slot-scope="scope">
            <span v-if="scope.row.dataType == 'day'">日</span>
            <span v-if="scope.row.dataType == 'week'">周</span>
            <span v-if="scope.row.dataType == 'month'">月</span>
            <span v-if="scope.row.dataType == 'year'">年</span>
          </template>
        </el-table-column>
        <el-table-column prop="deviceName" label="电表名称" align="left" width="180"/>
      </DiluTable>
    </div>
    <!--查询电价-->
    <PriceList :project="searchParams.project" :dialogVisible="dialogVisible" @handleClose="handleClose"/>
    <!--关联电表-->
    <MeterList :project="searchParams.project" :meterVisible="meterVisible" @handleClose="handleClose"/>
  </div>
</template>
 
 <script>
 import DiluTable from "@/components/public/dilu-table.vue";
 import PriceList from "./module/priceList.vue"; 
 import MeterList from "./module/meterList.vue"; 
 import { mapState } from "vuex";
 export default {
   data() {
     return {
      searchParams: {
        pageSize: 12,
        pageNum: 1,
        project: null,
        deviceId: null,
        dataType: "hour",
        createdAt: []
      },
      tableConfig: {
        isTree: false,
        isPage: true,   
      },
      deviceList: [],
      projectInfo: {},
      hourData: [],
      hourTotal: 0,
      staticData: [],
      staticTotal: 0,
      dialogVisible: false,
      meterVisible: false,
     };
   },
   components: {
    DiluTable,
    PriceList,
    MeterList
   },
   computed: {
    ...mapState(["projectCurrentRowData"]),
   },
   mounted() {
    this.projectInfo=this.projectCurrentRowData;
    this.searchParams.project=this.projectInfo.projectCode;
    this.loadDevice();
   },
   methods: {
    formatDate(row) {
      if (row.ptime!=undefined&&row.ptime.length>=16) {
          return row.ptime.substring(11,16)+'~'+row.dtime.substring(11,16);
      } else {
        return row.dtime.substring(11,16);
      }
    },
    loadDevice() {
      this.request.deviceMeters({project:this.searchParams.project}).then((res) => {
        if (res.code == 0) {
          this.deviceList=res.data;
        }
      });
    },
    goSearch() {
      const that=this;
      if (that.searchParams.dataType=='hour') {
        this.request.hourEnergy(this.searchParams).then((res) => {
          if (res.code == 0) {
            this.hourData=res.data;
            this.hourTotal=res.dataMaxCount;
          }
        });
      } else {
        this.request.staticEnergy(this.searchParams).then((res) => {
        if (res.code == 0) {
          this.staticData=res.data;
          this.staticTotal=res.dataMaxCount;
        }
      });
      }
    },
    currentChange(e) {
      this.searchParams.pageNum = e;
      this.goSearch();
    },
    dianJia() {
      this.dialogVisible=true;
    },
    guanLian() {
      this.meterVisible=true;
    },
    handleClose() {
      this.meterVisible=false;
      this.dialogVisible=false;
    }
  }
 };
 </script>
 
 <style lang="scss" scoped>
  .fixed-project {
    position: fixed; 
    top: 70px; 
    left: 420px;
    height: 32px;
    line-height: 32px;
    border-radius: 5px;
    color: black;
    text-align: left;
    font-size: small;
    z-index: 999;
  }
  .search {
    margin-bottom: 15px;
    ::v-deep(.el-form) {
      .el-form-item--mini.el-form-item {
        margin-bottom: 0;
      }
      .el-form-item__label {
        line-height: 40px;
      }
    }
  }

  .project-table {
    height: 100%;
  }

 </style>